import { useState } from "react";
import styles from "./MobileShell.module.scss";

export interface AvatarProps {
  /** Photo URL; falls back to the initials `mark` when absent OR when the image fails to load. */
  url: string | null | undefined;
  /** The initials fallback (e.g. "MF") shown when there is no usable photo. */
  mark: string;
  /** The larger 48px variant (the account-sheet profile card); default is the 36px row/header size. */
  large?: boolean;
  /** A rounded SQUARE rather than a circle — the person/band shape split the whole app follows. A band
      identity (the artist IS the band) renders square; a person face stays a circle (the default). */
  square?: boolean;
}

/**
 * An avatar shared by the mobile header + account sheet — the photo when one loads, else the initials mark.
 * A circle for a person, a rounded square for a band (`square`). The `onError` fallback matters because a
 * stale/broken photo URL must never render a torn image icon; it degrades to initials.
 */
export function Avatar({ url, mark, large, square }: AvatarProps) {
  const [broken, setBroken] = useState(false);
  const hasPhoto = !!url && !broken;
  const base = large ? styles.accountAvatarLg : styles.accountAvatar;
  return (
    <span className={square ? `${base} ${styles.accountAvatarSquare}` : base}>
      {hasPhoto ? (
        <img className={styles.accountAvatarImg} src={url} alt="" onError={() => setBroken(true)} />
      ) : (
        mark
      )}
    </span>
  );
}
